export function formatDate(date) {
  const weekday = new Date(date).toLocaleDateString(undefined, { weekday: 'long'})
  const dayOfMonth = new Date(date).toLocaleDateString(undefined, { day: 'numeric'})
  const suffix = getNumberSuffix(date.getDate());
  return `${weekday} ${dayOfMonth}${suffix}`;
}

export function getSQLDateFormat(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getNumberSuffix(number) {
  if (number >= 11 && number <= 13) {
    return 'th';
  }
  const lastDigit = number % 10;
  switch (lastDigit) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
